import { AnamnesisFormType } from "@/modules/patients/detail/progress-note/components/progress-note-editable/anamnesis-section"
import { useProgressNoteFormContext } from "@/modules/patients/detail/progress-note/hooks/useProgressNoteFormStore"
import { useStoreFormState } from "@/modules/patients/detail/progress-note/hooks/useStoreFormState"

export const useProgressNoteAnamnesisForm = (id: string, anamnesis: string | null) => {
  const progressNoteForms = useProgressNoteFormContext((state) => state.progressNoteForms)

  const storeForm = progressNoteForms.get(id)?.anamnesisForm

  const storeFormValue = storeForm?.getValues()

  let defaultValues: Partial<AnamnesisFormType>

  if (storeFormValue) {
    defaultValues = { ...storeFormValue, formIsDirty: false }
  } else {
    defaultValues = {
      anamnesis: anamnesis ?? "",
      formIsDirty: false,
    }
  }

  const storeFormState = useStoreFormState(storeForm)

  return { defaultValues, storeFormState }
}
